import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { GachaResultItem } from './GachaResultItem';
import { GachaItem } from 'src/replicant/gacha/gacha.ruleset';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (result: boolean) => void;
const ui = uiConfig.buruburu.care.confirmation;

export default class PopupGachaResults extends PopupBasic {
  private close: CloseHandler;
  private content: FlexBoxView;
  private okButton: ButtonScaleViewWithText;
  private continueButton: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      tracking: {
        feature: Feature.GACHA._,
        $subFeature: Feature.GACHA.PURCHASE,
      },
      width: 547,
      height: 738,
    });

    this.close = opts.close;
    this.buttonClose.removeFromSuperview();
    this.message.removeFromSuperview();

    const root = new FlexBoxView({
      superview: this.box,
      width: this.box.style.width,
      height: this.box.style.height,
      flex: {
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      },
    });

    this.content = new FlexBoxView({
      superview: root,
      flex: {
        width: 470,
        height: 500,
        alignItems: 'stretch',
        justifyContent: 'center',
        flexWrap: 'wrap',
        flexGrow: 1,
        paddingLeft: 10,
        paddingRight: 5,
      },
    });

    this.okButton = new ButtonScaleViewWithText({
      ...ui.okButton,
      superview: this.box,
      localeText: () => i18n('basic.okay'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(false);
      },
      tracking: {
        feature: Feature.GACHA._,
        $subFeature: Feature.GACHA.RESULTS_OK,
      },
    });

    this.continueButton = new ButtonScaleViewWithText({
      ...ui.okButton,
      superview: this.box,
      localeText: () => i18n('basic.continue'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(true);
      },
      tracking: {
        feature: Feature.GACHA._,
        $subFeature: Feature.GACHA.RESULTS_CONTINUE,
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init({ results }: { results: GachaItem[] }) {
    super.init({
      title: i18n('gacha.results.title'),
    });

    const multiple = results.length > 1;

    results.forEach((item) => {
      this.content.addSubview(new GachaResultItem(item, multiple));
    });

    this.fitContent(multiple);
  }

  private fitContent(multiple: boolean) {
    this.box.updateOpts({
      width: 557,
      height: multiple ? 800 : 633,
    });

    this.okButton.updateOpts({
      x: this.box.style.width / 4 - ui.okButton.width / 2,
      y: this.box.style.height - ui.okButton.height - 20,
    });
    this.continueButton.updateOpts({
      x: (3 * this.box.style.width) / 4 - ui.okButton.width / 2,
      y: this.box.style.height - ui.okButton.height - 20,
    });
  }
}
